<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-rocket fa-fw"></i>Atividades
          </h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="pull-right">
          <a
            class="btn btn-default"
            @click="
              addButton.seeForm = !addButton.seeForm;
              activity = {};
            "
          >
            <span v-if="addButton.seeForm">
              <i class="fa fa-search fa-fw"></i>Buscar
            </span>
            <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
          </a>
          <br />
          <br />
          <br />
        </div>

        <div class="col-lg-12">
          <div class="panel panel-default" v-if="addButton.seeForm">
            <div class="panel-body">
              <form role="form" @submit.stop.prevent="validateForm">
                <input v-model="activity.id" type="hidden" />
                <div class="form-group">
                  <label>id</label>
                  <input v-model="activity.id" class="form-control" disabled />
                </div>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="check-ativ"
                    v-model="activity.enabled"
                    :checked="activity.enabled"
                  />
                  <label class="form-check-label" for="check-ativ">
                    Ativo
                  </label>
                </div>
                <div class="form-group">
                  <label>Nome</label>
                  <input v-model="activity.name" class="form-control" />
                </div>
                <div class="form-group">
                  <label>Descricao</label>
                  <input v-model="activity.description" class="form-control" />
                </div>
                <p>&nbsp</p>

                <div class="panel panel-default">
                  <div class="panel-body">
                    <h3><i class="fa fa-list fa-fw"></i> Documentos</h3>

                    <hr />
                    <a
                      href="#"
                      @click.prevent.stop="addRule()"
                      class="btn btn-success btn-block"
                    >
                      <i class="fa fa-plus fa-fw"></i> Adicionar Documento
                    </a>
                    <hr />
                    <div
                      class="panel panel-info"
                      v-for="(rule, index) in rules"
                      v-bind:key="index"
                    >
                      <div class="panel-body">
                        <form class="form-inline">
                          <div class="form-group">
                            <input
                              class="form-control input-sm col-xs-1"
                              placeholder="Nome... "
                              v-model="rule.name"
                              @input="updateFilename(rule)"
                              size="20"
                              required
                            />
                          </div>
                          <div class="form-group">
                            <input
                              class="form-control input-sm col-xs-1"
                              v-model="rule.filename"
                              readonly
                              placeholder="nome-do-arquivo ..."
                              size="20"
                              required
                            />
                          </div>
                          <div class="form-group">
                            <input
                              class="form-control input-sm col-xs-1"
                              v-model="rule.order"
                              placeholder="Ordem... "
                              maxlength="2"
                              size="2"
                              required
                            />
                          </div>
                          <div class="checkbox">
                            <label>
                              <input
                                type="checkbox"
                                :checked="rule.enabled"
                                class="form-control"
                                v-model="rule.enabled"
                              />
                              Ativo
                            </label>
                          </div>
                          <div class="checkbox">
                            <label>
                              <input
                                class="form-control"
                                type="checkbox"
                                v-model="rule.required"
                                :checked="rule.required"
                              />
                              Obrigatório
                            </label>
                          </div>

                          <div class="checkbox">
                            <label>
                              <input
                                class="form-control"
                                type="checkbox"
                                :checked="rule.expirationRequired"
                                v-model="rule.expirationRequired"
                              />
                              Tem expiração
                            </label>
                          </div>
                          <div class="form-group">
                            <label> Setor</label>
                              <select class="form-control" v-model="rule.sectorId" required>
                                <option disabled>Escolha um Setor</option>
                                <option 
                                  v-for="sector in sectors"
                                  :key="sector.id"
                                  v-bind:value="sector.id">
                                  {{sector.name}}
                                </option>
                              </select>
                          </div>
                          <div class="pull-right">
                            <div class="form-group">
                              <a
                                class="btn btn-sm btn-danger"
                                @click.prevent="removeItem(rule, index)"
                              >
                                <i class="fa fa-trash"></i
                              ></a>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <button type="submit" class="btn btn-lg btn-block btn-info">
                  Salvar
                </button>
              </form>
            </div>
          </div>
          <div v-else class="panel panel-default">
            <div class="panel-body">
              <form>
                <div class="form-group">
                  <input
                    v-model="search"
                    class="form-control"
                    placeholder="Buscar..."
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div v-if="filtred.length">
          <div class="col-lg-4" v-for="activity in filtred" :key="activity.id">
            <div class="panel panel-default">
              <div class="panel-heading">                
                <b
                  data-toggle="tooltip"
                  data-placement="top"
                  v-bind:title="activity.name"
                  >{{ activity.name.substring(0, 25) }}
                  <i
                    v-if="activity.enabled"
                    class="fa fa-check-circle-o fa-fw text-success"
                  ></i>
                  <i v-else class="fa fa-times fa-fw text-danger"></i>
                </b>
                <div class="pull-right">
                  <div class="btn-group btn-group-xs" role="group">
                    <a
                      @click.stop="edit(activity.id)"
                      class="btn btn-sm btn-primary"
                      ><i class="fa fa-pencil fa-fw"></i
                    ></a>
                    <a
                      @click="
                        showModal = 1;
                        show = activity.id;
                      "
                      class="btn btn-sm btn-danger"
                      ><i class="fa fa-trash fa-fw"></i
                    ></a>
                  </div>
                  <br />
                </div>
                <br />
              </div>
              <div class="panel-body">
                <p>
                {{ limitedDescription(activity.description) }}
                </p>
              </div>
            </div>
            <Modal v-if="showModal === 1 && show === activity.id">
              <i
                slot="close"
                @click="
                  showModal = null;
                  yes = null;
                "
                >&times;</i
              >
              <h2 slot="header">
                <i class="fa fa-times fa-fw"></i>Remover Atividade
              </h2>
              <div slot="body">
                <h4>
                  Deseja realmente remover a atividade
                  <strong>{{ activity.name }}?</strong>
                </h4>
              </div>
              <div slot="footer">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="
                    yes = true;
                    showModal = null;
                  "
                  @click.stop="remove(activity.id)"
                >
                  Confirmar
                </button>
                <button
                  class="btn btn-default"
                  @click="
                    yes = null;
                    showModal = null;
                  "
                >
                  fechar
                </button>
              </div>
            </Modal>
          </div>
        </div>
        <Modal v-if="showModal === 2">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-exclamation-circle fa-fw"></i>Cadastro de Atividade
          </h2>
          <div slot="body">
            <div
              class="alert alert-success alert-small"
            ><i class="fa fa-exclamation"></i>
              Atividade cadastrada com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <Modal v-if="showModal === 3">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-times fa-fw"></i>Exclusão de Atividade
          </h2>
          <div slot="body">
            <div
              class="alert alert-success alert-small"
            ><i class="fa fa-exclamation"></i>
              Atividade excluída com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <div v-else-if="!filtred.length">
          <div class="alert alert-info">
            <p>
              <i class="fa fa-exclamation fa-fw"></i>Nenhum registro foi
              encontrado
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>
import string from "../../mixins/string";
import Modal from "../../components/ui-elements/Modal.vue";

export default {
  name: "Activity",
  inject: ["loading"],
  components: { Modal },
  data() {
    return {
      search: "",
      addButton: { seeForm: false },
      activity: {},
      rules: [],
      activities: [],
      show: null,
      yes: null,
      showModal: null,
      sector: {},
      sectors: [],
    };
  },
  mounted() {
    this.loading.value = true;
    this.$http
      .get("activity")
      .then((response) => {
        this.activities = response.data;
        this.$http
          .get("sector").then((response) => {
            this.sectors = response.data.content;
          })
      })
      .finally(() => {
        this.$nextTick(() => {
          $('[data-toggle="tooltip"]').tooltip();
        });

        setTimeout(() => (this.loading.value = false), 1000);
      });
  },
  methods: {
    addRule() {
      this.rules.push({});
    },

    send() {
      this.loading.value = true;

      this.activity.rules = this.rules;

      if (this.activity.id) {
        this.$http
          .put(`/activity/${this.activity.id}`, this.activity)
          .then((response) => {
            this.activities = this.activities.filter(
              (item) => item.id != this.activity.id
            );
            this.activities.push(response.data);
            this.activity = {};
            this.rules = [];
            this.addButton.seeForm = false;
            this.showModal = 2;
          })
          .catch((error) => {
            console.log(error);
          });
        setTimeout(() => (this.loading.value = false), 1000);
      } else {
        this.$http
          .post("/activity", this.activity)
          .then((response) => {
            this.activity = {};
            this.rules = [];
            this.activities.push(response.data);
            this.addButton.seeForm = false;
            this.showModal = 2;
            setTimeout(() => (this.loading.value = false), 1000);
          })
          .catch((error) => {
            console.log(error);
          });
        setTimeout(() => (this.loading.value = false), 1000);
      }
    },
    edit(id) {
      this.loading.value = true;
      this.$http
        .get(`/activity/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.activity = response.data;
          this.rules = response.data.rules;
        })
        .catch((error) => {
          console.log(error);
        });
      setTimeout(() => (this.loading.value = false), 1000);
    },
    remove(id) {
      this.loading.value = true;
      const confirm = this.yes;

      if (confirm) {
        this.$http
          .delete(`/activity/${id}`)
          .then((response) => {
            this.activities = this.activities.filter((item) => item.id != id);
            this.showModal = 3;
          })
          .catch((error) => alert(error));
        setTimeout(() => (this.loading.value = false), 1000);
      }
      setTimeout(() => (this.loading.value = false), 1000);
    },
    removeItem(rule, index) {
      this.$http
        .delete(`rule/${rule.id}`)
        .then((response) => {})
        .catch((error) => console.log(error))
        .finally(() => {
          this.rules.splice(index, 1);
        });
    },
    updateFilename(rule) {
      rule.filename = string.methods.slugfy(rule.name);
    },
    limitedDescription(activityDescription) {
      return (activityDescription.length <= 30)? activityDescription : `${activityDescription.substring(0, 30)}...`;
    },

    validateForm() {

      if(!this.activity.name || !this.activity.description) {
          alert("Preencha todos os campos")
      }
      else{
        this.send()
      }

    },
  },
  computed: {
    filtred() {
      const search = this.search.toLowerCase().trim();
      let result = [];

      if (!search) {
        result = this.activities;
      }

      result = this.activities.filter(
        (a) => a.name.toLowerCase().indexOf(search) > -1
      );

      return result.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },    

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Activity.vue